module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "EMIT_AVIRIS3_Data_Insight_Banner_v2.5bfb21a2.jpg";